import { Tooltip, chakra, useBoolean } from '@chakra-ui/react';
import * as React from 'react';
import { useTimeout } from 'usehooks-ts';

export const SpecialTooltip: React.FC<{ allowSpecialTooltip: boolean }> = ({
  children,
  allowSpecialTooltip,
}) => {
  const [isOpen, setIsOpen] = useBoolean();

  useTimeout(setIsOpen.on, allowSpecialTooltip ? 1000 : null);

  if (allowSpecialTooltip) {
    return (
      <Tooltip
        label="Join the live event here!"
        placement="top"
        hasArrow
        p="4"
        maxWidth="36"
        textAlign="center"
        fontSize="md"
        isOpen={isOpen}
      >
        <chakra.span
          onMouseEnter={setIsOpen.off}
          sx={{ '> *': { w: 'full' } }} // make any inner contents full width
        >
          {children}
        </chakra.span>
      </Tooltip>
    );
  }

  return <>{children}</>;
};
